import { useLanguage } from "../../i18n/LanguageContext";
import { siteConfig } from "../../config/site";
import { images } from "../../config/images";
import { Reveal } from "../Reveal";
import { SmartImage } from "../SmartImage";

export const Highlights = () => {
  const { t } = useLanguage();
  return (
    <section className="section" data-testid="highlights-section">
      <div className="container-x grid gap-14 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <Reveal className="lg:sticky lg:top-32">
            <p className="eyebrow">{t.highlights.eyebrow}</p>
            <h2 className="h2 mt-4">{t.highlights.title}</h2>
            <div className="mt-10 grid grid-cols-2 gap-4">
              <SmartImage src={images.kitchen} alt="Voll ausgestattete Gemeinschaftsküche der Kola Pension" className="aspect-[4/5] rounded-xl" />
              <SmartImage src={images.hallwayPortrait} alt="Flur der Kola Pension mit Blick in ein Zimmer" className="aspect-[4/5] rounded-xl mt-10" />
            </div>
          </Reveal>
        </div>
        <ol className="lg:col-span-7 divide-y divide-sand-200">
          {t.highlights.items.map((item, i) => (
            <Reveal key={item.title} as="li" delay={0.05 * i} className="grid gap-4 py-8 sm:grid-cols-[4rem_1fr] first:pt-0" >
              <span className="font-display text-3xl text-clay/70" aria-hidden>{String(i + 1).padStart(2, "0")}</span>
              <div>
                <h3 className="font-display text-xl md:text-2xl font-medium" data-testid={`highlight-${i}-title`}>{item.title}</h3>
                <p className="mt-2 text-charcoal-500 leading-relaxed">{item.text}</p>
              </div>
            </Reveal>
          ))}
          <Reveal as="li" className="py-8">
            <p className="rounded-2xl bg-sand-50 px-5 py-4 text-sm text-charcoal-700" data-testid="highlight-long-stay">
              {siteConfig.longStayConfirmed ? t.highlights.longStay : t.highlights.longStay}
            </p>
          </Reveal>
        </ol>
      </div>
    </section>
  );
};
